import {
    Craft,
    EMRR,
    EquipmentClass,
    JCCostType,
    LaborClass,
    LaborCode,
    OrderSegmentStatus,
    OrderSegmentStatusProgression,
    PayType,
    PurchaseOrderPayTerms,
    ResourceCategory,
    RevenueCode,
    SegmentCallType,
    ServiceCenter,
    ServiceCenterDivision,
    SMCostType,
    VistaCompanyInfo
} from "@msidata/service-pro-api-schema";

export interface Codes {
    [name: string]: any[];
}

export const codes: Codes = {};

export type AnyVistaCode =
    | Craft
    | EMRR
    | EquipmentClass
    | JCCostType
    | LaborClass
    | LaborCode
    | OrderSegmentStatus
    | OrderSegmentStatusProgression
    | PayType
    | PurchaseOrderPayTerms
    | ResourceCategory
    | RevenueCode
    | SegmentCallType
    | ServiceCenter
    | ServiceCenterDivision
    | SMCostType
    | VistaCompanyInfo;

export type VistaCodesDictionary<T extends AnyVistaCode> = {
    [K in T["entityName"]] : Omit<T, "entityName">[];
}

export const vistaCodes: VistaCodesDictionary<AnyVistaCode> = {} as VistaCodesDictionary<AnyVistaCode>;
